(function () {

    angular.module("app").constant("commonFunctions", {
        invoke: safeInvoke,
        compareDates: compareDates,
        replaceAll: replaceAll,
        stringFormat,
    });


    /**
    * Invokes a callback if and only if it is a function.
    * It uses rest parameters to forward optional parameters to the callback
    * @param {Function | null | undefined} callback 
    * @param  {...any} args 
    * @returns 
    */
    function safeInvoke(callback, ...args) {
        if (!angular.isFunction(callback)) {
            return;
        }

        return callback(...args);
    }

    /**
     * 
     * @param {Date} left 
     * @param {Date} right 
     * @returns 
     */
    function compareDates(left, right) {
        if (left < right)
            return -1;
        if (left > right)
            return 1;
        return 0;
    }

    /**
     * 
     * @param {any} value
     * @param {any} toReplace
     * @param {any} newValue
     * @returns
     */
    function replaceAll(value, toReplace, newValue){
        if (!value || !toReplace) return value;
        while (value.indexOf(toReplace) > -1)
            value = value.replace(toReplace, newValue);
        return value;
    }

    /**
     * Replaces placeholders between curly braces in a template string.
     * E.g. stringFormat("This is an {type} example.", { type: "simple" }) // This is a simple example.
     * @param {any} template
     * @param {any} values
     * @returns
     */
    function stringFormat(template, values) {
        return template.replace(/{(.*?)}/g, (_, offset) => values[offset]);
    }
})();